import { useActivitySummaryContext } from '../../../context'

export function useData() {
  const [{ filterSet, defaultFilters }] = useActivitySummaryContext()

  return {
    filterSet,
    defaultFilters,
  }
}
